<mat-drawer-container class="trace-drawer-container" [hasBackdrop]="false">
    <mat-drawer #drawer [mode]="'side'" [ngClass]="{'blast-device-drawer': vehicleListDrawerOpen || geofenceRecordDrawerOpen}">
        <ng-container *ngIf="vehicleTraceTelemetryEnabled$ | async; else legacyVehicleList">
            <div class="vehicle-telemetry-panel">
                <div class="vehicle-telemetry-action">
                    <button mat-stroked-button (click)="showDrawingManager('Point')"
                        class="add-device-location-button" [disabled]="disableAddDevice">
                        Add Device Location
                    </button>
                </div>

                <ng-container *ngIf="(vehicleLocations$ | async) !== undefined; else vehicleTelemetryLoader">
                <div class="telemetry-header full-width">
                    <div class="telemetry-title">Vehicle Telemetry</div>
                    <div class="telemetry-visible-count">
                        {{ selectedVehicleCount }} of {{ vehicleProperties.length }} visible
                    </div>

                    <div class="telemetry-summary">
                        <div class="telemetry-summary-item">
                            <span class="telemetry-label">
                                <mat-icon>speed</mat-icon>
                                Avg speed
                            </span>
                            <strong>{{ formatSpeed(fleetAverageSpeedMph) }}</strong>
                        </div>
                        <div class="telemetry-summary-item">
                            <span class="telemetry-label">
                                <mat-icon>timer</mat-icon>
                                Total idle
                            </span>
                            <strong>{{ formatDuration(totalIdleTimeSeconds) }}</strong>
                        </div>
                    </div>
                </div>

                <div class="full-width vehicle-list-container">
                    <div class="vehicle-telemetry-list">
                        <div *ngFor="let vehicleProp of vehicleProperties" class="vehicle-telemetry-card"
                            [class.vehicle-hidden]="!vehicleProp[2]">
                            <div class="vehicle-card-content">
                                <div class="vehicle-card-name-row">
                                    <span class="vehicle-color-indicator" [style.background]="vehicleProp[1]"></span>
                                    <strong>{{ vehicleProp[0].name }}</strong>
                                    <button mat-icon-button class="vehicle-visibility-button"
                                        [attr.aria-label]="vehicleProp[2] ? 'Hide vehicle on map' : 'Show vehicle on map'"
                                        [matTooltip]="vehicleProp[2] ? 'Hide from map' : 'Show on map'"
                                        (click)="toggleVehicleVisibility(vehicleProp[0].id)">
                                        <mat-icon>{{ vehicleProp[2] ? 'visibility' : 'visibility_off' }}</mat-icon>
                                    </button>
                                    <button mat-icon-button class="vehicle-expand-button"
                                        [attr.aria-label]="isVehicleExpanded(vehicleProp[0].id) ? 'Hide idle history' : 'Show idle history'"
                                        [matTooltip]="isVehicleExpanded(vehicleProp[0].id) ? 'Hide details' : 'Show details'"
                                        (click)="toggleVehicleDetails(vehicleProp[0].id)">
                                        <mat-icon>{{ isVehicleExpanded(vehicleProp[0].id) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                                    </button>
                                </div>

                                <ng-container *ngIf="getVehicleTelemetry(vehicleProp[0].id) as telemetry">
                                    <div class="vehicle-metrics">
                                        <div class="vehicle-metric">
                                            <span class="telemetry-label">
                                                <mat-icon>speed</mat-icon>
                                                Avg speed
                                            </span>
                                            <strong>{{ formatSpeed(telemetry.averageSpeedMph) }}</strong>
                                        </div>
                                        <div class="vehicle-metric">
                                            <span class="telemetry-label">
                                                <mat-icon>timer</mat-icon>
                                                Idle time
                                            </span>
                                            <strong>{{ formatDuration(telemetry.idleTimeSeconds) }}</strong>
                                        </div>
                                        <div class="vehicle-metric">
                                            <span class="telemetry-label">
                                                <mat-icon>route</mat-icon>
                                                Odometer
                                            </span>
                                            <strong>{{ formatOdometer(telemetry.latestOdometer) }}</strong>
                                        </div>
                                    </div>

                                    <div *ngIf="isVehicleExpanded(vehicleProp[0].id)" class="idle-history">
                                        <div class="idle-history-title">Idle history</div>

                                        <div *ngFor="let interval of telemetry.idleIntervals" class="idle-history-item">
                                            <div class="idle-history-event">
                                                <span class="idle-event-dot idle-start-dot"></span>
                                                <span>Idle Started</span>
                                                <time>{{ formatIdleEventTime(interval.startTime) }}</time>
                                            </div>
                                            <div class="idle-history-event">
                                                <span class="idle-event-dot idle-end-dot"></span>
                                                <span>{{ interval.endTime === null ? 'Still idle' : 'Idle Ended' }}</span>
                                                <time *ngIf="interval.endTime !== null">
                                                    {{ formatIdleEventTime(interval.endTime) }}
                                                </time>
                                            </div>
                                            <div class="idle-history-duration">
                                                {{ formatDuration(interval.durationSeconds) }}
                                            </div>
                                        </div>

                                        <div *ngIf="telemetry.idleIntervals.length === 0" class="idle-history-empty">
                                            No idle history for this duration
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                </ng-container>

                <ng-template #vehicleTelemetryLoader>
                    <div class="vehicle-telemetry-loader">
                        <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                    </div>
                </ng-template>
            </div>
        </ng-container>

        <ng-template #legacyVehicleList>
            <div class="legacy-vehicle-panel section start flex-column middle justify">
                <div>
                    <button mat-flat-button color="white" (click)="showDrawingManager('Point')"
                        class="mat-pickers button" [disabled]="disableAddDevice">
                        Add Device Location
                    </button>
                </div>

                <div class="full-height full-width legacy-vehicle-list">
                    <mat-selection-list #vehicles (selectionChange)="onVehicleSelectionChange($event)">
                        <mat-list-option *ngFor="let vehicleProp of vehicleProperties"
                            [value]="vehicleProp[0]" [selected]="vehicleProp[2]">
                            <button class="vehicle-color-indicator" [style.background]="vehicleProp[1]"></button>
                            {{ vehicleProp[0].name }}
                        </mat-list-option>
                    </mat-selection-list>
                </div>
            </div>
        </ng-template>
    </mat-drawer>
    <mat-drawer #geofenceDrawer [mode]="'side'" [ngClass]="{'geofence-drawer': vehicleListDrawerOpen || geofenceRecordDrawerOpen}">
        <div class="section start flex-column middle justify geofence-content">
            <div>
                Geofence Record
            </div>
        </div>
        <div class="container">
            <ng-container *ngIf="geofenceRecords$ | async as geofenceRecords">
                <div *ngFor="let record of geofenceRecords" class="geofence-data-content container"
                    [matBadge]="record.type === 'Geofence Entry' ? 'Entry' : 'Exit'" matBadgePosition="before"
                    matBadgeSize="large" 
                    [ngClass]="{'entry-badge': record.type === 'Geofence Entry', 'exit-badge': record.type === 'Geofence Exit'}">
                    <div class="centered-content muckpile-time-content">
                            <mat-icon mat-icon-button svgIcon="muckpile-tag" class="muckpile-time-icon"></mat-icon>
                        <div class="muckpile-vehicle-name">{{ record.muckpileName }} / {{ record.vehicleName }}</div>
                    </div>
                    <div class="centered-content muckpile-time-content">
                        <mat-icon class="muckpile-time-icon centered-content">access_time</mat-icon>
                        <div>{{ record.time| date: dateTimeFormat }}</div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="(geofenceRecords$ | async) === undefined" class="container centered-content full-width half-height">
            <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
          </div>
          <div *ngIf="(geofenceRecords$ | async)?.length === 0" class="container centered-content">
            <div class="container centered-content">
              <div>
                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
              </div>
              <div>No Data Found</div>
            </div>
          </div>
    </mat-drawer>

    <mat-drawer-content class="map-container"
        [ngClass]="{'map-drawer': vehicleListDrawerOpen || geofenceRecordDrawerOpen}">
        <div class="full-height full-width">
            <div *ngIf="(device$|async)==undefined" class="container-80 flex-column center middle full-width full-height">
                <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
            </div>
            <div #map class="full-height full-width"></div>
            <aside *ngIf="playbackPanelOpen" class="playback-controls" [class.playback-active]="playbackMode">
                <header class="playback-panel-header">
                                    <div class="playback-status">
                    <mat-icon>{{ playbackMode ? 'history' : 'wifi_tethering' }}</mat-icon>
                    <strong>{{ playbackMode ? 'Playback active' : 'Live view' }}</strong>

                </div>
                    <button mat-icon-button aria-label="Close playback" (click)="closePlaybackPanel()"><mat-icon>close</mat-icon></button>
                </header>

                <div class="playback-actions">
                    <mat-form-field appearance="outline" class="playback-select-field">
                        <mat-label>Duration</mat-label>
                        <mat-select [value]="playbackDurationKey" (valueChange)="selectPlaybackDuration($event)" aria-label="Playback time range">
                            <mat-option *ngFor="let option of durationOptions$ | async" [value]="option.key">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="playback-button-tooltip" [matTooltip]="'Vehicle did not move during this period.'" [matTooltipDisabled]="playbackHasLocations">
                        <button mat-stroked-button class="playback-action-button" (click)="togglePlayback()"
                            [disabled]="!playbackHasLocations || (vehicleLocations$ | async) === undefined">
                            <mat-icon>{{ playbackPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
                            {{ playbackMode ? (playbackPlaying ? 'Pause' : 'Play') : 'Playback' }}
                        </button>
                    </span>
                    <button *ngIf="playbackMode" mat-stroked-button class="playback-action-button" (click)="goLive()">
                        <mat-icon>my_location</mat-icon> Go Live
                    </button>
                </div>
                <div *ngIf="playbackMode" class="playback-timeline">
                    <input type="range" min="0" max="100" [value]="playbackProgress * 100" (input)="seekPlayback($any($event.target).value)" aria-label="Playback position">
                                        <span>{{ playbackMode ? formatPlaybackTime() : 'Select a duration and start playback' }}</span>
                    <mat-form-field appearance="outline" class="playback-speed-field">
                        <mat-label>Speed</mat-label>
                        <mat-select [value]="playbackSpeed" (valueChange)="setPlaybackSpeed($event)" aria-label="Playback speed">
                            <mat-option [value]="1">1×</mat-option>
                            <mat-option [value]="2">2×</mat-option>
                            <mat-option [value]="5">5×</mat-option>
                            <mat-option [value]="10">10×</mat-option>
                            <mat-option [value]="20">20×</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </aside>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
